import React, {useState, useEffect, useRef, useMemo} from 'react';
import { useHistory, useParams, useLocation } from "react-router-dom";
import Select from "react-select";
import { Button, Card, Col, Form } from "react-bootstrap";
import useAPI from '../../../hooks/useAPI';
import useToast from "../../../hooks/useToast";
import useUserContext from '../../../hooks/useUserContext';
import Required from "../../../components/Required";
import FindWithSelectComponent from "../../../components/FindWithSelect/FindWithSelectComponent";
import BackBtn from '../../../components/UI/BackBtn';
import { isAdmin, isModerator, isStratAdmin, isStratCurator } from '../../../services/rolesSvc';
import ForbiddenAccess from '../../../components/ForrbiddenAccessComponent/ForbiddenAccess';

// const projectsOptions = [
//   {
//     label: 'Научно-исследовательская политика и политика в области инноваций и коммерциализации разработок',
//     value: 0,
// 		policyId: 2,
//   },
//   {
//     label: 'СП1 Материалы и технологии для водородной и ядерной энергетики',
//     value: 1,
// 		strategyId: 1,
//   },
//   {
//     label: 'СП2 Дизайн и технологии функциональных материалов и систем',
//     value: 2,
// 		strategyId: 2,
//   },
//   {
//     label: 'СП3 Благополучие человека в условиях цифровой трансформации',
//     value: 3,
// 		strategyId: 3,
//   },
//   {
//     label: 'СП4 Академическое превосходство',
//     value: 4,
// 		strategyId: 4,
//   },
//   {
//     label: 'СП5 Образование: кадры для научно-технологического прорыва',
//     value: 5,
// 		strategyId: 5,
//   },
// ];

const getUserLabel = (user) => {
  return `${user.lastName} ${user.firstName} ${user.middleName}, ${user.post}`;
};

// Н687.210.003/23 - код л/с для теста

const ReceiptsPolicyAddContract = () => {
  const api = useAPI();
  const userCtx = useUserContext();
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const [foundedValues, setFoundedValues] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [selectedHead, setSelectedHead] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [selectedInstitute, setSelectedInstitute] = useState({});
  const [selectedProject, setSelectedProject] = useState({});
  const { stratId } = useParams();
  const [topicName, setTopicName] = useState('');
  const [searchHeadValue, setSearchHeadValue] = useState('');
  const history = useHistory();
  const location = useLocation();
  const addToast = useToast();

  const projectsOptions = useMemo(() => {
    return strategies.map((strategy) => ({
      label: strategy.name,
      value: strategy.id,
    }))}, [strategies]);

  useEffect(async () => {
    if (searchHeadValue) {
      const resp = await api.get(`/users?name=${searchHeadValue}`)
      setTeamMembers(resp?.map((value) => ({
        label: getUserLabel(value),
        value,
      })))
    }

    const strategies = await api.get('/mng/strategies?active=true');
    setStrategies(strategies);

    const inst = await api.get('/structure/institutes');
    setInstitutes(inst.map((e) => ({
      label: e.title,
      value: e.id,
    })))
  }, [searchHeadValue]);

  const timeoutRef = useRef(null);

  const loadOptions = (inputValue, callback) => {
    clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(async() => {
      const resp = await api.get(`/ones/pas?search=${inputValue}`, true)
      setFoundedValues(resp);
      callback(resp.map((value) => ({label: value.name, value: value.uid})))
    }, 1000)
};

  const getQueryParams = (queryString) => {  
    return queryString  
      .split('?')[1]
      ?.split('&')
      ?.reduce((acc, pair) => {  
          const [key, value] = pair.split('=');  
          acc[decodeURIComponent(key)] = decodeURIComponent(value);  
          return acc;  
      }, {});  
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    addToast.info('Идёт сохранение...');
    setIsDisabledButton(true);

    const result = await api.post(`/factdata/contracts`, {
      year: getQueryParams(location.search).year,
      paCode: selectedValue.code,
      topic: topicName ? topicName : '',
      personsInCharge: selectedInstitute?.label && selectedHead?.value?.sAMAccountName ? [{
        institute: selectedInstitute.label,
        sAMAccountName: selectedHead.value.sAMAccountName,
      }] : selectedInstitute?.label ? [{
        institute: selectedInstitute.label,
      }] : selectedHead?.value?.sAMAccountName ? [{
        sAMAccountName: selectedHead.value.sAMAccountName,
      }] : [],
      strategyId: selectedProject?.value || +stratId
    })

    if (!result.hasOwnProperty('error')) {
      addToast.success('Поступление сохранено');
      history.push(`/policies/${stratId}/budget?t=nioktrReceipts`);
    }

    setIsDisabledButton(false);
  }

  const selectValue = (item) => {
    setSelectedValue(foundedValues.find((e) => e.uid === item?.value));
  }

  const canEdit = useMemo(() => isAdmin(userCtx) || isModerator(userCtx) || isStratAdmin(userCtx, 4) || isStratCurator(userCtx, 4), [userCtx])

  return (
    <section className="page project-page">
      <div className="container">
        <BackBtn />

        {canEdit ? (
          <>
            <h3 style={{color: '#212529', margin: '20px 0 36px', textAlign: 'start'}}>Добавление карточки поступления</h3>
            <div style={{marginBottom: '20px'}}>
              <FindWithSelectComponent
                noOptionsMessage={() => 'Ничего не найдено'}
                placeholder="Введите внутренний номер л/c, присваиваемый в УрФУ"
                value={selectedValue?.code ? {value: selectedValue.uid, label: selectedValue.name} : ''}
                defaultOptions={[]}
                loadOptions={loadOptions}
                loadingMessage={() => 'Загрузка...'}
                onChange={selectValue}
                clearInputState={() => {
                  setSelectedValue(Object.keys(selectedValue).forEach(e => delete selectedValue[e]))
                  setTopicName('');
                  setSelectedHead({});
                  setSelectedInstitute({});
                }}
                marginRowZero={true}
              />
            </div>

            { selectedValue === undefined || !Object.keys(selectedValue).length ? null : (
              <Form onSubmit={handleSubmit}>
                <Card style={{marginBottom: '20px'}}>
                  <Card.Body style={{padding: '25px', display: 'flex', flexDirection: 'column', rowGap: '24px'}}>
                    <Form.Group as={Col}>
                      <Form.Label style={{color: '#7F7F7F'}}>Наименование темы</Form.Label>
                      <Form.Control
                        name={'topic'}
                        value={topicName}
                        placeholder="Введите название темы"
                        onChange={({ target }) => setTopicName(target.value)}
                        required={false}
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label style={{color: '#7F7F7F'}}>Руководитель темы</Form.Label>
                      <Select
                        placeholder="Введите ФИО и выберите из списка пользователей"
                        options={teamMembers}
                        onChange={setSelectedHead}
                        onInputChange={setSearchHeadValue}
                        noOptionsMessage={() => 'Список пуст'}
                        required={false}
                        isClearable={true}
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label style={{color: '#7F7F7F'}}>Институт (где работает руководитель темы)</Form.Label>
                      <Select
                        placeholder="Выберите институт из списка"
                        options={institutes}
                        onChange={setSelectedInstitute}
                        noOptionsMessage={() => 'Список пуст'}
                        required={false}
                        isSearchable={false}
                        isClearable={true}
                      />
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label style={{color: '#7F7F7F'}}>Стратегический проект или раздел научно-исследовательской политики Программы развития университета, в рамках реализации которого (ых) поступили денежные средства</Form.Label>
                      <Select
                        defaultValue={projectsOptions.find((opt) => opt.value === +stratId)}
                        options={projectsOptions}
                        onChange={setSelectedProject}
                        noOptionsMessage={() => 'Список пуст'}
                        isSearchable={false}
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body style={{display: 'flex', columnGap: '8px', padding: '30px 25px'}}>
                    <Button 
                      onClick={() => {
                        setIsDisabledButton(true);
                        new Promise(resolve => {
                          resolve(history.goBack())
                        }).finally(() => setIsDisabledButton(false));
                      }}
                      type={'button'} 
                      variant={'outline-secondary'}
                      disabled={isDisabledButton}
                    >
                      Отменить
                    </Button>
                    <Button disabled={isDisabledButton} type={'submit'}>Сохранить</Button>
                  </Card.Body>
                </Card>
              </Form>
            )}
          </>
        ) :
        <ForbiddenAccess />
      }
      </div>
    </section>
  );
};

export default ReceiptsPolicyAddContract;
